import { render } from "./XAttachModal.vue?vue&type=template&id=456efef7&scoped=true"
import script from "./XAttachModal.vue?vue&type=script&lang=js"
export * from "./XAttachModal.vue?vue&type=script&lang=js"

import "./XAttachModal.vue?vue&type=style&index=0&id=456efef7&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456efef7"]])

export default __exports__